var _rect, _rect2, _g, _g2, _g3, _path, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkOrderDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#EDE7F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 180,
    rx: 5,
    fill: "none",
    stroke: "#5652B0",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: 10,
    width: 25,
    height: 25,
    fill: "#7E57C2",
    stroke: "#5652B0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 10,
    width: 25,
    height: 25,
    fill: "#7E57C2",
    stroke: "#5652B0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 25,
    height: 25,
    fill: "#7E57C2",
    stroke: "#5652B0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -20,
    width: 25,
    height: 25,
    fill: "#9575CD",
    stroke: "#5652B0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: -20,
    width: 25,
    height: 25,
    fill: "#9575CD",
    stroke: "#5652B0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -50,
    width: 25,
    height: 25,
    fill: "#B39DDB",
    stroke: "#5652B0",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30,
    y: -30,
    width: 40,
    height: 20,
    fill: "#5652B0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: -10,
    width: 60,
    height: 15,
    fill: "#7E57C2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -30,
    width: 5,
    height: 40,
    fill: "#5652B0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -25,
    width: 15,
    height: 5,
    fill: "#5652B0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -15,
    width: 15,
    height: 5,
    fill: "#5652B0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -25,
    cy: 10,
    r: 5,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 10,
    r: 5,
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -25,
    width: 20,
    height: 20,
    fill: "#B39DDB",
    stroke: "#5652B0",
    strokeWidth: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 155)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: 0,
    width: 120,
    height: 10,
    fill: "#8D6E63"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: 5,
    width: 10,
    height: 5,
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40,
    y: 5,
    width: 10,
    height: 5,
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 5,
    width: 10,
    height: 5,
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 10,
    height: 5,
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    width: 10,
    height: 5,
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 5,
    width: 10,
    height: 5,
    fill: "#6D4C41"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -30,
    width: 30,
    height: 30,
    fill: "#9575CD",
    stroke: "#5652B0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -30,
    width: 30,
    height: 30,
    fill: "#9575CD",
    stroke: "#5652B0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: -30,
    width: 30,
    height: 30,
    fill: "#9575CD",
    stroke: "#5652B0",
    strokeWidth: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30 L50 10 L100 30 L150 10 L200 30 L250 10 L300 30 L350 10 L400 30 L450 10 L500 30 L550 10 L600 30 L650 10 L700 30 L750 10 L800 30",
    fill: "none",
    stroke: "#5652B0",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 65,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#5652B0",
    textAnchor: "middle"
  }, "BULK ORDER DISCOUNT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 105,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#5652B0",
    textAnchor: "middle"
  }, "15% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 135,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#5652B0",
    textAnchor: "middle"
  }, "The more you order, the more you save!")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkOrderDiscount);
export default __webpack_public_path__ + "static/media/bulk_order_discount.60c63b147bd84706b4991f0f514316d7.svg";
export { ForwardRef as ReactComponent };